import getReportsStore from ".";
import { apiCallWarnReport } from "../../api/report-api/api-call-handle-report";
import { TCorePage } from "../../Types";
import getCorePopUpStore from "../core/core-popup-store";
import getCoreUIStore from "../core/core-ui-store";

const warnReportOnDatabase = async (
  reportId: number,
  reportedUUID: string,
  reportedId: number,
  TBW_ids: number[],
  pageName: TCorePage
) => {
  getCoreUIStore().setIsLoading("REPORTS", true);
  const { status, data, code } = await apiCallWarnReport({
    reportId,
    reportedUUID,
    TBW_ids,
    pageName
  });

  getCoreUIStore().setIsLoading("REPORTS", false);
  if (status === "OK") {
    getCorePopUpStore().showSuccessMessage(data);
    getReportsStore().removePendingReport({ reportId, reportedId });
    getReportsStore().decreaseDashboardReportsCount();
    getReportsStore().decreaseDashboardReportedCount(reportedId);
  } else {
    getCorePopUpStore().showAlertMessage(code);
  }
  return status;
};

export default warnReportOnDatabase;
